import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Notification } from '../../models/notification/notification.model';
import { NotificationRole } from '../../models/notification/notificationRole.model';
import { PopupNotification } from '../../models/notification/notificationRole.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { retry } from 'rxjs/operator/retry';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class NotificationService {
  private service = "api/Notification"; //Controller Name
  private eventHelperService = "api/NotificationEvent"; //Controller Name
  private roleHelperService = "api/RoleManagement"; //Controller Name
  private servicePopup = "api/PopupNotification"; //Controller Name
  public notificationList: Notification[];
  public popupNotificationList: PopupNotification[];

  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  GetCustomerTypes() {
    return this.http.get(`${this.roleHelperService}/GetActiveRoles`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }
  GetNotificationEvents() {
    return this.http.get(`${this.eventHelperService}/GetNotificationEvents`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }
  GetNotificationActiveEvents() {
    return this.http.get(`${this.eventHelperService}/GetNotificationActiveEvents`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }
  GetPushNotification(roleId: number, userId: number) {
    return this.http.get(`${this.service}/GetPushNotification?roleId=` + roleId + '&userId=' + userId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }
  GetHeaderNotification(roleId: number, userId: number) {
    return this.http.get(`${this.service}/GetHeaderNotification?roleId=` + roleId + '&userId=' + userId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }
  GetPopupNotification(roleId: number, userId: number) {
    return this.http.get(`${this.service}/GetPopupNotification?roleId=` + roleId + '&userId=' + userId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  AddNotification(notification: Notification) {
    return this.http
      .post(`${this.service}`, notification, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  AddNotificationRole(notificationRole: NotificationRole[]): void {
    this.http
      .post(`${this.service}/PostNotificationRole`, notificationRole, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/notification-list"]);
      });
  }
  AddSalesNotification(notification: Notification): void {
    this.http
      .post(`${this.service}`, notification, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
      });
  }
  UpdateNotification(notification: Notification): void {
    this.http
      .put(`${this.service}`, notification, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/notification-list"]);
      });
  }

  GetNotifications() {
    return this.http.get(`${this.service}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetNotificationsGrid(pageNumber: number, pageSize: number, notificationEventID: number, searchKeyword: string, isActive: string) {
    return this.http.get(`${this.service}/GetNotificationsGrid?pageNumber=` + pageNumber + `&pageSize=` + pageSize + `&notificationEventID=` + notificationEventID + `&searchKeyword=` + searchKeyword + `&isActive=` + isActive, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetNotificationTypes() {
    return this.http.get(`${this.service}/GetNotificationTypes`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  //GetNotificationCount(customerTypeId: number) {
  //  return this.http.get(`${this.service}/GetNotificationCount?customerTypeId=` + customerTypeId)
  //    .map((response: Response) => response.json())
  //    .catch(this.errorHandler);
  //}
  GetNotificationCount(userId: number, roleId: number) {
    return this.http.get(`${this.service}/GetNotificationCount?userId=` + userId + '&roleId=' + roleId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  CheckNotification(userId: number, roleId: number) {
    return this.http.get(`${this.service}/CheckNotification?userId=` + userId + '&roleId=' + roleId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetNotificationById(id: string) {
    return this.http.get(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <Notification>response.json())
      .catch(this.errorHandler)
  }
  GetNotificationRolesByNotificationID(notificationID: number) {
    return this.http.get(`${this.service}/GetNotificationRoleByNotificationID?notificationID=` + notificationID, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetNotificationRoles() {
    return this.http.get(`${this.service}/GetNotificationRoles`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  
  DeleteNotification(id: string) {
    return this.http.delete(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }
  
  AddPopupNotification(model: PopupNotification) {
    return this.http
      .post(`${this.servicePopup}`, model, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  AddPopupNotificationLogo(formData: any, userId: number): void {
    this.http
      .post(`${this.servicePopup}/SavePopupNotificationImage?userId=` + userId, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        setTimeout(() => {
          this.router.navigate(["/popupNotification-list"]);
        }, 1000);

      });
  }
  GetPopupNotifications() {
    return this.http.get(`${this.servicePopup}/GetPopupNotifications`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  DeletePopupNotification(id: string) {
    return this.http.get(`${this.servicePopup}/DeletePopupNotification?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetPopupNotificationById(Id: string) {
    return this.http.get(`${this.servicePopup}/GetPopupNotificationById?id=` + Id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  UpdatePopupNotification(model: PopupNotification) {
    return this.http.post(`${this.servicePopup}/UpdatePopupNotification`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/notification/notification.service.ts